import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type State = {
  practiceTestId: number | null;
  classId: number | undefined;
  isRetake: boolean;
};

type Action = {
  setPracticeTestId: (practiceTestId: number | null) => void;
  setClassId: (classId: number | undefined) => void;
  setIsRetake: (isRetake: boolean) => void;
  clearPracticeTextIdStore: () => void;
};

const initial: State = {
  practiceTestId: null,
  classId: undefined,
  isRetake: false,
};

export const usePracticeTestIdStore = create<State & Action>()(
  persist(
    (set) => ({
      ...initial,
      setPracticeTestId: (practiceTestId: number | null) =>
        set(() => ({ practiceTestId })),
      setClassId: (classId: number | undefined) => set(() => ({ classId })),
      setIsRetake: (isRetake: boolean) => set(() => ({ isRetake })),
      clearPracticeTextIdStore: () => set({ ...initial }),
    }),
    {
      name: "practice-test-id-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
